import {useEffect, useMemo, useState} from 'react'
import {showErrorToast} from '../../../../shared/components/ToastUtils'
import {loadMailTemplates} from '../mail-template/Api'
import {IMailTemplateModel} from '../mail-template/MailTemplateModel'

/** Seçim listesi tek seferde yüklenir; şablon sayısı bunun altında kalır */
const OPTION_PAGE_SIZE = 1000

/**
 * Süreç adımı ve soru tanımı ekranlarındaki mail şablonu seçenekleri.
 * Pasif şablonlar listelenmez; yalnızca o şablon zaten seçiliyse görünür kalır
 * (selectedId geçilirse).
 */
export function useMailTemplateOptions(enabled = true, selectedId?: string | null) {
  const [templates, setTemplates] = useState<IMailTemplateModel[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) return
    setLoading(true)
    loadMailTemplates(0, OPTION_PAGE_SIZE)
      .then(({data}) => setTemplates(data.payload.content || []))
      .catch(() => showErrorToast('Mail şablonları yüklenemedi'))
      .finally(() => setLoading(false))
  }, [enabled])

  const options = useMemo(
    () =>
      templates
        .filter((template) => template.active !== false || template.id === selectedId)
        .map((template) => ({value: template.id || '', label: template.name})),
    [templates, selectedId]
  )

  return {templates, options, loading}
}
